import { render, staticRenderFns } from "./NewFacture.vue?vue&type=template&id=0de231c8&"
import script from "./NewFacture.vue?vue&type=script&lang=js&"
export * from "./NewFacture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports